<template>
  <div class="page">
    <!-- 顶部导航栏：返回按钮 + 标题（样式与其他子页面一致） -->
    <div class="nav-bar">
      <div class="nav-back" @click="goBack">
        <!-- 返回箭头 -->
        <svg viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </div>
      <div class="nav-title">购买彩票</div>
    </div>

    <!-- 选号方式区域：手动输入 / 随机生成 两个大卡片 -->
    <div class="option-list">
      <!-- 手动输入：自己挑选号码 -->
      <div class="option-card manual" @click="chooseWay('manual')">
        <div class="option-icon">
          <!-- 手写/编辑图标 -->
          <svg viewBox="0 0 24 24">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
          </svg>
        </div>
        <div class="option-name">手动输入</div>
        <div class="option-desc">自己选择心仪号码</div>
      </div>

      <!-- 随机生成：机选号码 -->
      <div class="option-card random" @click="chooseWay('random')">
        <div class="option-icon">
          <!-- 骰子图标，代表随机 -->
          <svg viewBox="0 0 24 24">
            <rect x="3" y="3" width="18" height="18" rx="3" />
            <circle cx="8.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
            <circle cx="15.5" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
            <circle cx="15.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
            <circle cx="8.5" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
          </svg>
        </div>
        <div class="option-name">随机生成</div>
        <div class="option-desc">机选号码，快捷方便</div>
      </div>

      <!-- 模型推荐：仅管理员(manager)、vip 用户可见；点击进入模型推荐出号页 -->
      <div v-if="canShowModel" class="option-card model" @click="chooseWay('model')">
        <div class="option-icon">
          <!-- 大脑/AI 图标，代表智能模型推荐 -->
          <svg viewBox="0 0 24 24">
            <path d="M12 2a4 4 0 0 0-4 4 4 4 0 0 0-2 7 4 4 0 0 0 2 7 4 4 0 0 0 8 0 4 4 0 0 0 2-7 4 4 0 0 0-2-7 4 4 0 0 0-4-4z" />
            <path d="M12 6v14" />
          </svg>
        </div>
        <div class="option-name">模型推荐</div>
        <div class="option-desc">AI 智能模型推荐号码</div>
      </div>
    </div>

    <!-- 底部免责备注：提醒用户本工具只提供出号服务，不能在线购彩 -->
    <div class="remark">
      备注：仅提供出号服务，本工具不提供任何彩票销售服务，线下实体店是唯一合法购彩渠道
    </div>
  </div>
</template>

<script>
import { canShowModelRec } from '@/utils/role'

export default {
  name: 'LotteryMange',
  computed: {
    // 模型推荐仅 manager（管理员）和 vip（VIP 用户）可见，判断逻辑抽到 utils/role.js 全局复用
    canShowModel() {
      return canShowModelRec()
    }
  },
  methods: {
    // 点击选号方式：manual=手动输入，random=随机生成，model=模型推荐
    chooseWay(way) {
      // 三种方式都进入出号页，用 query.source 区分，页面内部按方式显示不同内容
      this.$router.push({
        path: '/bet-num',
        query: { source: way }
      })
    },

    // 返回主页
    goBack() {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
/* 页面整体：与其他子页面一致的手机门户风格 */
.page {
  width: 100%;
  max-width: 480px;
  min-height: 100%;
  margin: 0 auto;
  background: #f5f6fa;
}

/* ===== 顶部导航栏 ===== */
.nav-bar {
  position: relative;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-back {
  position: absolute;
  left: 10px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-back svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-title {
  color: #fff;
  font-size: 16px;
}

/* ===== 选号方式卡片区域 ===== */
.option-list {
  padding: 20px 16px;
}

/* 单个大卡片：对应示意图中的红框按钮，手指好点按 */
.option-card {
  background: #fff;              /* 背景白色 */
  border: 2px solid #f56c6c;     /* 2px 红色实线边框 */
  border-radius: 12px;           /* 圆角 12px */
  padding: 24px 12px;            /* 上下内边距 24px，左右 12px */
  margin-bottom: 28px;           /* 卡片之间底部间距 28px */
  display: flex;                 /* 弹性布局 */
  flex-direction: column;        /* 子元素纵向排列 */
  align-items: center;           /* 子元素水平居中 */
  cursor: pointer;               /* 鼠标悬停显示"小手"，暗示可点击 */
  /* 按下去的过渡效果 */
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  /* 对 transform 和 box-shadow 两个属性做 0.15 秒的平滑过渡 */
}

/* 按下时轻微缩小，给用户“点到了”的反馈 */
.option-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 10px rgba(245, 108, 108, 0.25);
}

/* 图标圆形底 */
.option-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fef0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.option-icon svg {
  width: 30px;
  height: 30px;
  fill: none;
  stroke: #f56c6c;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.option-name {
  font-size: 20px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 6px;
}

.option-desc {
  font-size: 13px;
  color: #909399;
}

/* ===== 底部免责备注 ===== */
.remark {
  padding: 0 20px 30px;
  font-size: 12px;
  line-height: 1.8;
  color: #f56c6c; /* 红色醒目提示 */
}
</style>
